import { TriangleAlert } from "lucide-react";
import { useTranslation } from "react-i18next";
import { Typography } from "../ui";
import type { TErrorData } from "../../core/types/error-fallback"; // adjust import path/name as needed

const getErrorMessage = (error?: TErrorData | Error): string | undefined => {
  if (!error) return undefined;
  if (typeof (error as { message?: unknown }).message === "string") {
    return (error as { message: string }).message;
  }
  return undefined;
};

export default function ErrorDetails({
  error,
  errormsg,
  className,
}: {
  error?: TErrorData | Error;
  errormsg?: string;
  className?: string;
}) {
  const { t } = useTranslation("common");
  const resolvedMessage = errormsg ?? getErrorMessage(error);

  return (
    <section data-testid="error-fallback" className={className}>
      <div className="flex flex-col items-center justify-center p-4 text-center h-full">
        <TriangleAlert className="text-gray" />
        <Typography variant={"p"} affects={"semiBold"} className="text-gray">
          {t("ERRORS.HTTP.COULD_NOT_LOAD")}
        </Typography>
        <Typography variant={"article"} className="text-gray text-xs mt-1 ">
          {resolvedMessage ?? t("ERRORS.HTTP.PLEASE_TRY_AGAIN")}
        </Typography>
      </div>
    </section>
  );
}
